<template>
  <v-card outlined>
    <div class="px-5 pb-5" rounded="0">
      <div class="py-4">
        <icon-title
          text="Instrucciones"
          icon="mdi-file-document-alert-outline"
          title-class="text-h6 text-md-h6 ml-2"
        />
        <p class="text-center pt-2">
          Estimad@ <span class="font-weight-black">{{ userName }}</span
          >. Da instrucciones a tu BACKORDER ACTIVO para que te permita generar
          un nuevo pedido
        </p>
      </div>

      <table-toolbar
        hide-delete
        hide-export
        :search="searchQuery"
        @update:search="(e) => (searchQuery = e)"
        @refresh="loadReminders()"
      >
        <template #custom-message>
          <v-row
            dense
            align="center"
            justify="space-between"
            justify-sm="start"
            class="pb-4 pb-md-0 pl-md-4"
          >
            <v-col cols="12" md="auto">
              <v-select
                v-model="searchFilter"
                :items="searchFilters"
                :class="[
                  'w-100',
                  { 'min-wx-250 max-wx-250': !isMobileOrTablet },
                ]"
                placeholder="Filtrar por:"
                hide-details
                clearable
                dense
                solo
                @click:clear="searchFilter = null"
              ></v-select>
            </v-col>
          </v-row>
        </template>
      </table-toolbar>

      <reminders-table
        :items="reminders"
        :search="searchQuery"
        :filter="searchFilter"
        :loading="loadingReminders"
        :hidden-headers="hiddenTableHeaders()"
        hide-select
      />

      <material-status-helper class="my-5 my-md-5" />

      <div class="d-flex justify-end" justify="end">
        <v-btn class="green-button w-xs-100" @click="goToReminders">
          Ir a backorders
        </v-btn>
      </div>
    </div>
  </v-card>
</template>

<script>
  import { mapGetters, mapActions } from 'vuex';
  import TableToolbar from '@/components/tables/TableToolbar.vue';
  import RemindersTable from '@/components/tables/RemindersTable.vue';
  import IconTitle from '@/components/IconTitle.vue';
  import MaterialStatusHelper from '@/components/MaterialStatusHelper.vue';

  import { BACKORDER_SEARCH_FILTERS } from '@/core/constants/backorder';
  import { Roles } from '@/core/constants/roleConstants';

  export default {
    name: 'RemindersStep',
    components: {
      TableToolbar,
      RemindersTable,
      IconTitle,
      MaterialStatusHelper,
    },
    data: () => ({
      searchQuery: '',
      searchFilter: '',
      searchFilters: BACKORDER_SEARCH_FILTERS,
    }),
    computed: {
      ...mapGetters({
        user: 'auth/user',
      }),
      ...mapGetters('reminders', ['reminders', 'loadingReminders']),
      userName() {
        return this.user.name.trim();
      },
    },
    methods: {
      ...mapActions('reminders', [
        'loadReminders',
        'changeRemindersModalState',
      ]),
      goToReminders() {
        this.$emit('closeModal');
        this.$router.push({ name: 'backorders', query: { filter: 'all' } });
      },
      hiddenTableHeaders() {
        const hiddenHeadersByRoleMap = {
          [Roles.CUSTOMER_RETAIL]: [
            'seller',
            'manager',
            'customer',
            'regionalManager',
          ],
          [Roles.CUSTOMER_WHOLESALER]: [
            'seller',
            'manager',
            'customer',
            'regionalManager',
          ],
          [Roles.SELLER]: ['manager', 'seller', 'regionalManager'],
          [Roles.MANAGER]: ['manager', 'regionalManager'],
          [Roles.SUB_MANAGER]: ['manager', 'regionalManager'],
          [Roles.REGIONAL_MANAGER]: ['regionalManager'],
        };

        const roles = Object.keys(hiddenHeadersByRoleMap);

        for (const role of roles) {
          if (this.$hasAnyRole([role])) return hiddenHeadersByRoleMap[role];
        }
      },
    },
  };
</script>
